<template>
    <section id="devis" class="QuoteActions" :class="{ sending }">
      <!-- Icons row -->
      <div class="qa-icons">
        <!-- Approve (validate) -->
        <button class="qa-icon" @click="approve">
          <img class="qa-ico" :src="icons.check" alt="" />
          <span class="qa-link">VALIDER LE DEVIS</span>
        </button>
  
        <!-- Download -->
        <button class="qa-icon" @click="downloadPdf">
          <img class="qa-ico" :src="icons.download" alt="" />
          <span class="qa-link">TÉLÉCHARGER&nbsp; LE DEVIS</span>
        </button>
  
        <!-- Modify (scroll to form) -->
        <button class="qa-icon qa-muted" @click="scrollToForm">
          <img class="qa-ico" :src="icons.edit" alt="" />
          <span class="qa-link">MODIFIER LE DEVIS</span>
        </button>
      </div>
  
      <!-- Title -->
      <h3 class="qa-title" :class="isPhone ? 'raleway-semi-p15' : ''" id="modif">AJOUTER DES MODIFICATIONS AU DEVIS</h3>
  
      <!-- Change form -->
      <form class="qa-form" @submit.prevent="submitChange">
        <textarea
          v-model.trim="message"
          rows="6"
          :placeholder="placeholder"
          required
        ></textarea>
  
        <div class="qa-actions">
          <button type="submit" class="btn-primary" :disabled="sending">
            {{ sending ? 'Envoi…' : 'ENVOYER LA DEMANDE' }}
          </button>
          <!-- <button type="button" class="btn-link" @click="resetForm">ANNULER LA MODIFICATION</button> -->
        </div>
        <!-- <p class="qa-hint">
        <span class="qa-hint-ico">i</span>
        Envoyer une demande de modification <strong>n’équivaut pas</strong> à la
        validation du devis. Pour valider, utilisez le bouton
        <strong>« VALIDER LE DEVIS »</strong> en haut.
      </p> -->
      </form>
  
      <!-- Legal -->
      <p class="qa-legal mt-2">
        <span class="qa-legal-ico">!</span>
        La validation du devis par le client vaut acceptation des
        <a href="#cgv" class="qa-legal-link" @click.prevent="scrollToFod()">
          Conditions Générales de Ventes
        </a>.
      </p>
      <div id="toast-root">
        <transition name="fade" appear>
          <div v-if="!!toast" class="toast">{{ toast }}</div>
        </transition>
      </div>
<dialog ref="okDialog" class="cs-modal" aria-labelledby="okTitle">
  <div class="cs-modal__content">
    <div class="cs-modal__icon">✓</div>
    <h4 id="okTitle" class="cs-modal__title">Votre devis a été validé</h4>
    <p class="cs-modal__text">
      Notre équipe reviendra vers vous dans les plus brefs délais.
    </p>
    <div class="cs-modal__actions">
      <button class="btn-primary" @click="closeApprovalAndDownload">OK</button>
    </div>
  </div>
</dialog>

<dialog ref="sentDialog" class="cs-modal" aria-labelledby="sentTitle">
  <div class="cs-modal__content">
    <div class="cs-modal__icon">✓</div>
    <h4 id="sentTitle" class="cs-modal__title">Demande envoyée</h4>
    <p class="cs-modal__text">
      Votre demande a bien été envoyée. Notre équipe reviendra vers vous dans les plus brefs délais
    </p>
    <div class="cs-modal__actions">
      <button class="btn-primary" @click="closeSentModal">OK</button>
    </div>
  </div>
</dialog>

    </section>
  </template>
  
  <script>
  import fetcher from "../../packs/shared/api.js";
  import iconCheck    from "../../images/cc.svg";
  import iconDownload from "../../images/bb.svg";
  import iconEdit     from "../../images/aa.svg";

  export default {
    name: 'PublicQuoteActions',
    props: {
      /* Context shown in your emails */
      quoteNumber:   { type: String, default: '' },
      locationName:  { type: String, default: '' },
      customerName:  { type: String, default: '' },
  
      /* Formspree endpoints (create 2 forms in Formspree) */
      formspreeApproveUrl: { type: String, required: true },
      formspreeChangeUrl:  { type: String, required: true },
  
      /* Optional: if you want to ALSO notify your server later (commented in code) */
      approveWebhook: { type: String, default: '' },
      changeWebhook:  { type: String, default: '' }
    },
    data () {
      console.log(this.formspreeApproveUrl)
      console.log(this.formspreeChangeUrl)

      return {
        message: '',
        sending: false,
        toast: '',
        _toastTimer: null,
        icons: {
          check: iconCheck,
          download: iconDownload,
          edit: iconEdit
        },
        isPhone: window.innerWidth < 768,
      }
    },
    computed: {
      placeholder () { return 'Laissez un commentaire…' }
    },
    methods: {
      openSentModal () {
        const dlg = this.$refs.sentDialog
        if (dlg && typeof dlg.showModal === 'function') dlg.showModal()
        else alert('Votre demande a bien été envoyée. Notre équipe reviendra vers vous dans les plus brefs délais.')
      },
      closeSentModal () {
        const dlg = this.$refs.sentDialog
        if (dlg && typeof dlg.close === 'function') dlg.close()
      },
      showToast (msg, ms = 3000) {
      this.toast = msg
      clearTimeout(this._toastTimer)
      this.$nextTick(() => {
        this._toastTimer = setTimeout(() => { this.toast = '' }, ms)
      })
    },
      notify (m) { this.toast = m; setTimeout(() => (this.toast = ''), 3000) },
  
      // Open “Save as PDF” dialog
      downloadPdf () {
      // wait one tick so global print CSS is applied (Safari/Firefox friendly)
      this.$nextTick(() => { setTimeout(() => window.print(), 0) })
    },
  
      // Approve: email via Formspree + print dialog
      async approve () {
        try {
          this.sending = true
          const payload = {
            _subject: `Validation du devis ${this.quoteNumber}`,
            type: 'approval',
            quote_number: this.quoteNumber,
            customer_name: this.customerName,
            location_name: this.locationName,
            url: window.location.href
          }
          await fetch(this.formspreeApproveUrl, {
            method: "POST",
            body: payload,
            headers: { Accept: "application/json" }
          });
          const formData = new FormData();
        Object.entries(payload).forEach(([key, value]) => {
          formData.append(key, value);
        });

          
        await fetch('https://formspree.io/f/xdklywwb', {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" }
        });

          // if (!r.ok) throw new Error(`Formspree HTTP ${r.status}`)
  
          // if (this.approveWebhook) { await fetch(this.approveWebhook, { method: 'POST' }) }
  
          this.showToast('Devis validé. Enregistrez le PDF puis signez-le via DocuSign.')
          this.openApprovalModal()
        } catch (e) {
          console.error(e);          
          this.showToast('Devis validé. Enregistrez le PDF puis signez-le via DocuSign.')
        } finally { this.sending = false }
      },
  
      async submitChange () {
        try {
          this.sending = true
          const payload = {
            _subject: `Demande de modification – Devis ${this.quoteNumber}`,
            type: 'change_request',
            message: this.message || "",
            quote_number: this.quoteNumber,
            customer_name: this.customerName,
            location_name: this.locationName,
            url: window.location.href
          }
          const formData = new FormData();
        Object.entries(payload).forEach(([key, value]) => {
          formData.append(key, value);
        });

          
        await fetch('https://formspree.io/f/xjkjndnk', {
          method: "POST",
          body: formData,
          headers: { Accept: "application/json" }
        });

          this.resetForm()
          this.openSentModal()         
        } catch (e) {
          console.error(e)
          this.openSentModal()
        } finally {
          this.sending = false
        }
      },
      openApprovalModal () {
      const dlg = this.$refs.okDialog
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal()
      else alert('Votre devis a été validé. Notre équipe reviendra vers vous dans les plus brefs délais.')
    },
    closeApprovalAndDownload () {
      const dlg = this.$refs.okDialog
      if (dlg && typeof dlg.close === 'function') dlg.close()
      this.downloadPdf()
    },
  
      resetForm () { this.message = '' },
      scrollToForm () { document.getElementById('modif')?.scrollIntoView({ behavior: 'smooth' }) },
      scrollToFod () { document.getElementById('cgv')?.scrollIntoView({ behavior: 'smooth' }) }

    },
    beforeDestroy () { clearTimeout(this._toastTimer) }
  }
  </script>
  
  <style scoped>
  .QuoteActions { padding: 14px 0 24px; position: relative; }
  .qa-icons {
    display:grid;
    grid-template-columns: repeat(3, 1fr);
    gap: clamp(24px, 5vw, 80px);
    justify-items: center;
    margin: 10px auto 28px;
    max-width: 1100px;
  }
  .qa-icon { background: transparent; border:0; cursor: pointer; display:grid; gap:10px; justify-items:center; color:#2d5f49; }
  /* .qa-icon .qa-ico { width:56px; height:56px; } */
  .qa-link { font-family:'Raleway',sans-serif; font-weight:700; text-decoration: underline; text-underline-offset:3px; }
  .qa-muted .qa-link { color:#90a29a; }
  
  .qa-title { text-align:left; max-width:1100px; margin: 14px auto 10px; padding: 0 12px;
    font:700 22px/1.2 'Raleway',sans-serif; color:#25463a; }
  
  .qa-form { max-width:1100px; margin:0 auto; padding:0 12px; }
  .qa-form textarea {
    width:100%; resize:vertical; background:#fff; border-radius:14px;
    border:1px solid #e2e6e4; padding:18px 20px; font-size:16px; line-height:1.6; color:#0d0d0d;
    outline:none; box-shadow:0 1px 0 rgba(0,0,0,.03);
  }
  .qa-actions { display:flex; gap:18px; align-items:center; margin:18px 0 8px;}
  .btn-primary { background:#3B6152; color:#fff; border:0; border-radius:8px; padding:14px 22px; font-weight:700; cursor:pointer; }
  .btn-link {  background:#3B6152; border:0; color:#3B6152; font-weight:700; text-decoration:underline; cursor:pointer; }
  .btn-primary:hover { background:#3B6152; color:#fff; border:0; border-radius:8px; padding:14px 22px; font-weight:700; cursor:pointer; }

  .qa-legal { max-width:1100px; margin:8px auto 0; padding:0 12px; color:#3B6152; }
  .qa-legal-ico { display:inline-grid; place-items:center; width:22px; height:22px; border-radius:999px; background:#e6f0ec; color:#3B6152; font-weight:800; margin-right:8px; }
  
  .toast {
    position:fixed; bottom:18px; left:50%; transform:translateX(-50%);
    background:#203f34; color:#fff; padding:10px 14px; border-radius:10px; box-shadow:0 8px 24px rgba(0,0,0,.22); z-index:2000;
  }
  .fade-enter-active,.fade-leave-active{transition:opacity .18s ease;}
  .fade-enter,.fade-leave-to{opacity:0;}
  
  @media (max-width: 860px){
    .qa-icons{ grid-template-columns:1fr; gap:18px; }
    .qa-icon .qa-ico{ width:50px;height:50px; }
    .qa-link{ font-size:18px; }
  }
  
  @media print { .QuoteActions, .AnchorNav { display:none !important; } }
  .qa-hint {
  margin: 6px 0 0;
  color: #2c3a35;
  background: #f2f6f4;
  border: 1px solid #e2e6e4;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.5;
}

.qa-icon { background: transparent; border:0; cursor: pointer; display:grid; gap:10px; justify-items:center; color:#2d5f49; }
.qa-icon .qa-ico { width:65px; height:65px; display:block; }

.qa-hint-ico {
  display:inline-grid; place-items:center;
  width:18px; height:18px; margin-right:6px;
  border-radius:999px; font-weight:800;
  background:#dfe9e5; color:#2d5f49;
}
#toast-root { position: fixed; left: 0; right: 0; bottom: 24px; pointer-events: none; z-index: 9999; }
.toast {
  margin: 0 auto; max-width: 520px; width: fit-content;
  background: #111; color: #fff; font-weight: 700;
  padding: 12px 16px; border-radius: 10px; letter-spacing: .2px;
  box-shadow: 0 8px 30px rgba(0,0,0,.25);
  pointer-events: auto;
}

.fade-enter-active, .fade-leave-active { transition: opacity .22s ease, transform .22s ease; }
.fade-enter, .fade-leave-to { opacity: 0; transform: translateY(8px); }

.fade-enter-from, .fade-leave-to { opacity: 0; transform: translateY(8px); }

@page { size: A4; margin: 12mm; }

* {
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}

@media print {
  img { max-width: 100% !important; height: auto !important; page-break-inside: avoid; }

  .AnchorNav, .Hero__galleryBtn { display: none !important; }

  .Hero__overlay { background: linear-gradient(180deg, rgba(0,0,0,.30), rgba(0,0,0,.55)) !important; }
}
.cs-modal {
  border: none;
  padding: 0;
  border-radius: 14px;
  width: min(520px, 92vw);
  box-shadow: 0 20px 50px rgba(0,0,0,.25);
}
.cs-modal::backdrop {
  background: rgba(0,0,0,.35);
}
.cs-modal__content {
  padding: 24px 22px 20px;
  text-align: center;
}
.cs-modal__icon {
  width: 44px; height: 44px; line-height: 44px;
  margin: 0 auto 10px;
  border-radius: 50%;
  border: 2px solid #1f7a4a;
  color: #3B6152;
  font-weight: 700;
  font-size: 22px;
}
.cs-modal__title { margin: 4px 0 6px; font-size: 20px; font-weight: 700; color: #133; }
.cs-modal__text { margin: 0 0 18px; color: #455; }
.cs-modal__actions {display: flex; justify-content: center; gap: 8px; }

.btn-primary {
  background: #3B6152;
  color: #fff;
  border: 0;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}
.btn-primary:disabled { opacity: .6; cursor: not-allowed; 
  background: #3B6152;
  color: #fff;
  border: 0;
  padding: 10px 18px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active { transition: opacity .25s; }
.fade-enter-from, .fade-leave-to { opacity: 0; }
.toast {
  position: fixed; left: 50%; bottom: 24px; transform: translateX(-50%);
  background: #111; color: #fff; padding: 10px 14px; border-radius: 8px;
}
.qa-legal-link {
  text-decoration: underline;
  color: #2d5f49;
  font-weight: 700;
}


  </style>  